import React, { useState } from 'react';
import DatePicker from 'react-datepicker';

interface DateRangePickerProps {
  selectedDates: {
    startDate: Date | null;
    endDate: Date | null;
  };
  onChange: (startDate: Date, endDate: Date) => void;
  id?: string;
  className?: string;
  calendarIcon?: any;
  setHandleToggleChange?: any;
  disabled?: any;
  placeholder?: string;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  selectedDates,
  onChange,
  className,
  placeholder
}) => {
  const [startDate, setStartDate] = useState<Date | null>(
    selectedDates.startDate
  );
  const [endDate, setEndDate] = useState<Date | null>(selectedDates.endDate);

  const handleChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      onChange(start, end);
    }
  };

  const dateToUTC = (date: Date | null) => {
    let newDate = null;
    if (date) {
      return new Date(date.getTime() + date.getTimezoneOffset() * 60000)
    }
    return newDate;
  }

  return (
    <div className='d-flex'>
      <DatePicker
        selected={startDate}
        onChange={handleChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        placeholderText={placeholder ?? 'Select a date range'}
        dateFormat='yyyy-MM-dd'
        className={`${className} borderblack`}
        monthsShown={2}
        showIcon
        calendarIconClassname='calendarIcon'
        onChangeRaw={(e) => {
          const input = e.target.value;
          if (!input) return;

          const [start, end] = input.split(' - ').map((date) => {
            const parsedDate = dateToUTC(new Date(date.trim()));
            if (!parsedDate) {
              return null;
            }
            return parsedDate;
          });

          if (start && end) {
            setStartDate(start);
            setEndDate(end);
            onChange(start, end);
          }
        }}
      />
    </div>
  );
};

export default DateRangePicker;
